import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import AnimatedButton from './AnimatedButton';

interface NavbarProps {
  onNavigate?: (view: 'home' | 'investor') => void;
  currentView?: 'home' | 'investor';
}

const Navbar: React.FC<NavbarProps> = ({ onNavigate, currentView }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Início', href: '#inicio', view: 'home' as const },
    { name: 'Sobre', href: '#sobre', view: 'home' as const },
    { name: 'Soluções', href: '#solucoes', view: 'home' as const },
    { name: 'Diferenciais', href: '#diferenciais', view: 'home' as const },
    { name: 'Contato', href: '#contato', view: 'home' as const },
  ];

  const waLink = "https://wa.me/5573998595834?text=Olá,%20sou%20investidor%20e%20gostaria%20de%20detalhes";

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled || currentView === 'investor' ? 'bg-white/80 backdrop-blur-md py-4 border-b border-gray-100 shadow-sm' : 'bg-transparent py-6'}`}>
      <div className="container mx-auto px-6 flex items-center justify-between">
        <button onClick={() => onNavigate?.('home')} className="flex items-center">
          <Logo className="h-10 md:h-12" />
        </button>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          {currentView === 'home' ? (
            navLinks.map((link) => (
              <a key={link.name} href={link.href} className="text-sm font-semibold text-gray-700 hover:text-[#39B54A] transition-colors tracking-wide">
                {link.name}
              </a>
            ))
          ) : (
            <button onClick={() => onNavigate?.('home')} className="text-sm font-semibold text-gray-700 hover:text-[#39B54A] transition-colors tracking-wide">
              Voltar para Home
            </button>
          )}
          
          <button 
            onClick={() => onNavigate?.('investor')}
            className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${currentView === 'investor' ? 'bg-[#39B54A] text-white' : 'bg-[#39B54A]/10 text-[#39B54A] hover:bg-[#39B54A]/20'}`}
          >
            Seja Investidor
          </button>

          <AnimatedButton 
            text="Fale agora" 
            href={waLink} 
            className="!px-8 !py-3.5 !min-w-[180px]"
          />
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-gray-900 p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {mobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white absolute top-full left-0 w-full border-b border-gray-100 animate-fadeIn shadow-xl">
          <div className="flex flex-col p-6 space-y-4">
            <button onClick={() => { onNavigate?.('investor'); setMobileMenuOpen(false); }} className="text-left py-2 text-lg font-bold text-[#39B54A]">Seja Investidor</button>
            {navLinks.map((link) => (
              <button 
                key={link.name} 
                onClick={() => { onNavigate?.('home'); setMobileMenuOpen(false); }}
                className="text-left py-2 text-lg font-bold text-gray-900 hover:text-[#39B54A]"
              >
                {link.name}
              </button>
            ))}
            <AnimatedButton 
              text="Falar no WhatsApp" 
              href={waLink} 
              className="w-full !min-w-0"
            />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;